// extracted by mini-css-extract-plugin
export default {"button":"LandingPage_button__zhVYQ"};